export default {
  word: {
    en: "Word",
    pt: "Palavra",
  },
  accept: {
    en: "Accept",
    pt: "Aceita",
  },
  rejects: {
    en: "Rejects",
    pt: "Rejeita",
  },
  notIncludes: {
    en: "Symbols that not include in alphabet",
    pt: "Símbolos que não pertencem ao alfabeto",
  },
};
